import styled from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const Wrapper = styled.label`
  ${fontBold};
  margin-bottom: ${size(0.5)};
  font-size: 0.875rem;
`;
